import { render, staticRenderFns } from "./tops_page.vue?vue&type=template&id=0d5e75fc"
import script from "./tops_page.vue?vue&type=script&lang=js"
export * from "./tops_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports